/* eslint-disable new-cap */
import { gql } from "@apollo/client";
import { List as list } from "../fragments";

const CREATE_LIST = props => gql`
  mutation CreateList($input: CreateListInput!) {
    createList(input: $input) {
      error
      list {
        ${list(props)}
      }
      success
    }
  }
`;

const DELETE_LIST = gql`
  mutation DeleteList($input: DeleteListInput!) {
    deleteList(input: $input) {
      error
      success
    }
  }
`;

const UPDATE_LIST = props => gql`
  mutation UpdateList($input: UpdateListInput!) {
    updateList(input: $input) {
      error
      list {
        ${list(props)}
      }
      success
    }
  }
`;

const SHARE_LIST = gql`
  mutation ShareList($input: ShareListInput!) {
    shareList(input: $input) {
      error
      success
      list {
        id
        name
        sharedWith {
          id
          email
          meta
        }
      }
    }
  }
`;

const COPY_LIST = props => gql`
  mutation CopyList($input: CopyListInput!) {
    copyList(input: $input) {
      error
      list {
        ${list(props)}
      }
      success
    }
  }
`;

export { CREATE_LIST, DELETE_LIST, UPDATE_LIST, SHARE_LIST, COPY_LIST };
